/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../lib/component-base';
import AsyncElasticsearchSelect from './AsyncElasticsearchSelect';

@componentBase('AirlineSelect')
export default class AirlineSelect extends Component {
  static propTypes = {
    name: PropTypes.string,
    airline: PropTypes.object,
    inputTitle: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    styleProps: PropTypes.object,
    secondaryAction: PropTypes.func,
  };

  onChange = (option, triggeredByEnter) => {
    if (this.props.onChange) {
      this.props.onChange(option, triggeredByEnter);
    }
  }

  onDelete = (option) => {
    if (this.props.onDelete) {
      this.props.onDelete();
    } else if (this.props.onChange) {
      this.props.onChange(option);
    }
  }

  onBlur = (event) => {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  render() {
    const {
      name,
      airline,
      inputTitle,
      styleProps,
      secondaryAction,
    } = this.props;

    const formatQuery = input => ({ gram: input });
    const formatItem = item => `(${item._id}) ${item._source.shortName}`;
    const airlineCode = airline &&
                        airline.value &&
                        airline.value._source &&
                        airline.value._source.fs;

    return (
      <div>
        <AsyncElasticsearchSelect
          name={name || 'airline'}
          input={airlineCode}
          selectedItem={airline}
          initializerSource='airlineLookup'
          inputTitle={inputTitle || 'Airline'}
          placeholder='Example: AA or American Airlines'
          onChange={this.onChange}
          queryFormatter={formatQuery}
          itemFormatter={formatItem}
          searchSource='airline'
          styleProps={styleProps}
          secondaryAction={secondaryAction}
          onDelete={this.onDelete}
          onBlur={this.onBlur}
        />
      </div>
    );
  }
}
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./src/components/lib/AirlineSelect.js